import React from "react";
import styled from "styled-components";

import { ModalService } from "../../service/modal-service";
import SongItem from "./song-item";
import { Col, Text, Button, Row } from "../../comps";
import Error from "../../module/views/error";
import MaterialIconButton from "@material-ui/core/IconButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Theme } from "../../theme/theme-provider";

import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

const Wrapper = styled(Col)`
  width: 100%;
  height: 100%;
  background: ${({ theme }) => theme.color.BLACK_0};
  overflow: hidden;
  align-items: center;
  justify-content: ${({ empty }) => (empty ? "" : "space-between")};
`;

const Head = styled(Row)`
  width: 94%;
  height: 8%;
  padding-left: 6px;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.color.GRAY_2};
`;

const ListWrapper = styled(Col)`
  width: 94%;
  height: 82%;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.color.GRAY_2};
  }
  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.color.GRAY_1};
    border-radius: 20px;
  }
`;

export default ({ playlist, addSongs, onBack }) => {
  const addAll = () => {
    addSongs(playlist.songs);
    ModalService.closeModal();
  };

  const haveSongs = playlist.songs && playlist.songs.length > 0;

  return (
    <Wrapper empty={!haveSongs}>
      <Head>
        <MaterialIconButton onClick={onBack}>
          <FontAwesomeIcon
            style={{ fontSize: "16px", color: `#fff` }}
            icon={faArrowLeft}
          />
        </MaterialIconButton>
        <Text
          fontSize="20px"
          width="90%"
          color={Theme.textColor.light}
          marginLeft="6px"
          textAlign="left"
        >
          {"add songs"}
        </Text>
      </Head>
      {haveSongs && (
        <Button
          width="50%"
          height="6%"
          buttonTextColor={Theme.textColor.light}
          borderRadius="50"
          buttonBackground={Theme.color.BLUE_4}
          buttonName="add all"
          buttonFontSize="12px"
          size="small"
          onClick={addAll}
        />
      )}
      {haveSongs && (
        <ListWrapper>
          {playlist.songs.map((song) => (
            <SongItem song={song} addSongs={addSongs} />
          ))}
        </ListWrapper>
      )}
      {!haveSongs && (
        <Error style={{ marginTop: "30px" }} message="Empty Playlist" />
      )}
    </Wrapper>
  );
};
